import hyperdom from 'hyperdom'

export default class DeclarationVerificationBanner {
  constructor ({config}) {
    this.config = config
  }
  render () {
    return (
      this.config.features.showDeclarationVerificationBanner ? <div class="declaration-verification-banner">Your discount will be checked and removed if we are unable to verify.</div> : undefined
    )
  }
}
